export default class Accounting {
    price = 0;
    transportFee = 0;
    paid = 0;
}
